import { combineReducers } from 'redux';
import authenticationReducer from './authenticationReducer';
import documentReducer from './documentReducer';
import searchReducer from './searchReducer';
import notificationHandlingReducer from './notificationHandlingReducer';
import scoreCardReducer, {
    digAppsSelectorReducer,
    scoreCardFiltersReducer
} from './scoreCardReducer';
import clauseReducer from './clauseReducer';
import headerNavigationReducer from './headerNavigationReducer';
import notificationReducer from './notificationReducer';
import contentControlReducer from './contentControlReducer';
import contractsReducer from './contractsReducer';
import analyzeDocumentAnimationReducer from './analyzeDocumentAnimationReducer';
import ssoReducer from './ssoReducer';
import baseReducer from './baseReducer';
import mixPanelReducer from './mixPanelReducer';

export default combineReducers({
    auth: authenticationReducer,
    document: documentReducer,
    search: searchReducer,
    notificationHandling: notificationHandlingReducer,
    scoreCard: scoreCardReducer,
    scoreCardFilters: scoreCardFiltersReducer,
    digAppsSelector: digAppsSelectorReducer,
    clause: clauseReducer,
    headerNavigation: headerNavigationReducer,
    notification: notificationReducer,
    contentControl: contentControlReducer,
    contract: contractsReducer,
    documentAnimation: analyzeDocumentAnimationReducer,
    sso: ssoReducer,
    base: baseReducer,
    mixPanel: mixPanelReducer
});
